import React from 'react';
import './Guarantee.css';

const Guarantee = () => {
  return (
    <div className="guarantee-container">
        <h1>OUR GUARANTEE</h1>
        <p>
            <b>Here's how it works: </b>
            There is no payment until the work is complete, and when it's complete, if you are not satisfied with the work, the job is free!
            In the future, if you encounter any issues related to the repairs we've performed, simply reach out to us, and we'll promptly address the matter. If we can't, we will return your money.
            IT'S THAT SIMPLE!
            <br /><br />
            We take pride in providing top-notch auto body repair services and ensuring customer satisfaction at every step.
            With our guarantee, you can trust that our skilled technicians will deliver exceptional results. Whether it's dent repair, scratch repair, or major collision repair, we stand behind our workmanship. 
            


            <br /><br />
            We believe in building long-term relationships with our valued customers, and our guarantee reflects our dedication to delivering the highest quality service. 
            {/* Choose Mobile Dent And Scratch Repair today, for a seamless repair experience with the assurance that your satisfaction is our top priority. */}
        </p>
    </div>
  )
}

export default Guarantee